import { render } from "./AlertBox.vue?vue&type=template&id=5cb7beae&scoped=true"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=5cb7beae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5cb7beae"

export default script